import React from 'react';
import { staticImage } from '../constants';
import { useTranslation } from '../hooks/useTranslation';

interface WelcomeScreenProps {
  language: string;
  user?: string;
  onSignupClick: () => void;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({
  language,
  user,
  onSignupClick
}) => {
  const { t } = useTranslation(language);
  const features = [
    {
      icon: '🌍',
      text: t('welcome.features.globalMarket')
    },
    {
      icon: '🎯',
      text: t('welcome.features.personalized')
    },
    {
      icon: '⚡',
      text: t('welcome.features.instantCheckout')
    }
  ];

  return (
    <div style={{
      padding: '20px',
      backgroundColor: '#f8f8f8',
      borderRadius: '15px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {/* Header Section */}
      <div style={{
        marginBottom: '4px'
      }}>
        <p style={{
          margin: 0,
          color: '#333',
          fontSize: '15px',
          lineHeight: '1.6'
        }}>
          {t('welcome.intro')}
        </p>
      </div>

      {/* Features List */}
      <div style={{ marginBottom: '5px' }}>
        {features.map((feature, index) => (
          <div key={index} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            marginBottom: '0',
            color: '#666'
          }}>
            <span style={{ fontSize: '16px' }}>{feature.icon}</span>
            <span style={{ fontSize: '14px', fontWeight: '500' }}>
              {feature.text}
            </span>
          </div>
        ))}
      </div>

      {/* Example Queries */}
      <div style={{ marginBottom: '5px' }}>
        <h4 style={{
          color: '#333',
          fontSize: '14px',
          fontWeight: '600'
        }}>
          {t('welcome.trendingPrompts')}
        </h4>
        
        {/* Good Examples */}
        <div style={{ marginBottom: '5px' }}>
          <div style={{
            backgroundColor: '#f5f5f5',
            borderRadius: '8px',
            fontSize: '12px',
            fontStyle: 'italic',
            lineHeight: '1.6',
            color: '#000',
          }}>
            { language === 'zh-TW' && <>
              <div>1. 請推薦最優惠報價（註明酒類品牌 + 指定特定年份或範圍皆可，例如：<b>紅顏容酒莊 2010-2019</b>）</div>
              <div>2. 我想購買<b>1990年份的波爾多紅酒</b>，預算約$1500。</div>
              <div>3. 請給我推薦勃艮第村田白酒，<b>價格$600以下</b>。</div>
              <div>4. 請建議<b>現在適宜飲用</b>的超級托斯卡納紅酒最優惠報價。</div>
            </> }
            { language === 'zh-CN' && <>
              <div>1. 推荐最优惠报价（注明酒类品牌 + 指定特定年份或范围皆可，例如：<b>红颜容酒庄 2010-2019</b>）</div>
              <div>2. 我想购买<b>1990年份的波尔多红酒</b>，预算约$1500。 </div>
              <div>3. 请给我推荐勃艮第村田白酒，<b>价格$600以下</b>。</div>
              <div>4. 请建议<b>现在适宜饮用</b>的超级托斯卡纳红酒最优惠报价。</div>
            </> }
            { language !== 'zh-TW' && language !== 'zh-CN' && <>
              <div>1. Please recommend best offer (specific wine brand + vintage eg. <b>Haut Brion 2010-2019</b>)</div>
              <div>2. I want to buy <b>1990s Bordeaux Red</b> around $1500</div>
              <div>3. Burgundy village white <b>below $600</b></div>
              <div>4. Best offer Super Tuscan red <b>ready to drink now</b> around $1000</div>
            </> }
          </div>
        </div>

        {/* Question */}
        <div style={{ marginBottom: '5px' }}>
          <p style={{
            margin: 0,
            color: '#333',
            fontSize: '15px',
            fontWeight: '500'
          }}>
            {t('welcome.question')}
          </p>
        </div>
      </div>

    </div>
  );
};

export default WelcomeScreen;